/*
 * This file is part of the ARODAX Admin package.
 *
 * (c) ARODAX a.s.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

/* eslint-disable camelcase */

import has from 'lodash/has'
import set from 'lodash/set'
import get from 'lodash/get'
import map from 'lodash/map'
import unset from 'lodash/unset'

/**
 * This mixin provides various methods to handle errors and validations.
 *
 * @deprecated This mixin file will be moved in 7.0.0
 */
const errorHandlerMixin = {
  data () {
    return {
      $_errorHandlerMixin_violations: {}
    }
  },
  methods: {
    /**
     * Build violations from the error object
     * @param {error} err error object contains the violations
     */
    buildViolations (err) {
      if (!has(err, 'data.violations')) {
        return
      }

      const violations = {}

      map(err.data.violations, (value) => {
        set(violations, value.propertyPath, value.message)
      })

      this.$_errorHandlerMixin_violations = violations
    },
    /**
     * Build violation at the custom propertyPath
     * @param {error} err Error object
     * @param propertyPath
     */
    buildViolation (err, propertyPath) {
      let message = ''

      if (has(err, 'data.title')) {
        message = message + err.data.title
      }

      if (has(err, 'data.detail')) {
        message = message + ': ' + err.data.detail
      }

      if (!has(this.$_errorHandlerMixin_violations, propertyPath)) {
        set(this.$_errorHandlerMixin_violations, propertyPath, [])
      }

      this.$_errorHandlerMixin_violations[propertyPath].push(message)
    },
    /**
     * Clear all violations
     */
    clearViolations () {
      this.$_errorHandlerMixin_violations = []
    },
    /**
     * Clear violation at the given property path
     * @param propertyPath
     */
    clearViolation (propertyPath) {
      unset(this.$_errorHandlerMixin_violations, propertyPath)
    },
    /**
     * Check if there is violation for the given propertyPath
     * @param {string} propertyPath The property path of the violation
     * @returns {boolean}
     */
    hasViolation (propertyPath) {
      if (!propertyPath) {
        return false
      }

      return has(this.$_errorHandlerMixin_violations, propertyPath)
    },
    /**
     * Get the violation at the property path
     * @param {string} propertyPath The property path of the violation
     * @returns {boolean}
     */
    getViolation (propertyPath) {
      if (!propertyPath) {
        return false
      }

      return get(this.$_errorHandlerMixin_violations, propertyPath)
    }
  }
}

export { errorHandlerMixin }
